import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Imprint() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <div className="container max-w-4xl mx-auto py-12 px-4 space-y-8">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate(-1)}
          className="mb-4"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Zurück
        </Button>

        <div className="space-y-6">
          <div>
            <h1 className="text-4xl font-bold mb-2">Impressum</h1>
            <p className="text-muted-foreground">Angaben gemäß § 5 TMG</p>
          </div>

          <div className="bg-yellow-50 dark:bg-yellow-950/20 border border-yellow-200 dark:border-yellow-900 rounded-lg p-4 mb-6">
            <p className="text-sm text-yellow-800 dark:text-yellow-200">
              <strong>Hinweis:</strong> Dies ist eine Vorlage. Bitte ersetzen Sie ALLE Platzhalter [IN KLAMMERN] mit Ihren tatsächlichen Unternehmensdaten. Ein Impressum muss vollständig und korrekt sein.
            </p>
          </div>

          <div className="prose prose-slate dark:prose-invert max-w-none space-y-6">
            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">Angaben gemäß § 5 TMG</h2>
              <div className="bg-muted/50 rounded-lg p-4 space-y-2">
                <p className="font-medium text-foreground">[VOLLSTÄNDIGER FIRMENNAME MIT RECHTSFORM]</p>
                <p className="text-muted-foreground">[STRASSE UND HAUSNUMMER]</p>
                <p className="text-muted-foreground">[POSTLEITZAHL UND ORT]</p>
                <p className="text-muted-foreground">[LAND]</p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">Kontakt</h2>
              <div className="bg-muted/50 rounded-lg p-4 space-y-2">
                <p className="text-muted-foreground">
                  <span className="font-medium text-foreground">Telefon:</span> [TELEFONNUMMER]
                </p>
                <p className="text-muted-foreground">
                  <span className="font-medium text-foreground">Telefax:</span> [FAXNUMMER - Optional]
                </p>
                <p className="text-muted-foreground">
                  <span className="font-medium text-foreground">E-Mail:</span> [KONTAKT-E-MAIL]
                </p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">Handelsregister</h2>
              <div className="bg-muted/50 rounded-lg p-4 space-y-2">
                <p className="text-muted-foreground">
                  <span className="font-medium text-foreground">Registergericht:</span> [AMTSGERICHT]
                </p>
                <p className="text-muted-foreground">
                  <span className="font-medium text-foreground">Registernummer:</span> [HRB/HRA NUMMER]
                </p>
              </div>
              <p className="text-xs text-muted-foreground italic">
                Hinweis: Für GmbHs und UGs ist die Angabe des Handelsregisters Pflicht. 
                Bei Einzelunternehmen und GbRs entfällt dieser Abschnitt meist.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">Vertreten durch</h2>
              <div className="bg-muted/50 rounded-lg p-4 space-y-2">
                <p className="text-muted-foreground">
                  <span className="font-medium text-foreground">Geschäftsführer:</span> [NAMEN DER GESCHÄFTSFÜHRER]
                </p>
              </div>
              <p className="text-xs text-muted-foreground italic">
                Alternativ bei anderen Rechtsformen: „Inhaber", „Vorstand", „Vertretungsberechtigte Partner" etc.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">Umsatzsteuer-ID</h2>
              <div className="bg-muted/50 rounded-lg p-4">
                <p className="text-muted-foreground">
                  Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG:
                </p>
                <p className="font-medium text-foreground mt-1">[DE + 9 ZIFFERN]</p>
              </div>
              <p className="text-xs text-muted-foreground italic">
                Die USt-IdNr. ist für umsatzsteuerpflichtige Unternehmen in der Regel Pflicht.
                Sie erhalten diese vom Bundeszentralamt für Steuern.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">Wirtschafts-ID</h2>
              <div className="bg-muted/50 rounded-lg p-4">
                <p className="text-muted-foreground">
                  Wirtschafts-Identifikationsnummer gemäß § 139c AO:
                </p>
                <p className="font-medium text-foreground mt-1">[W-IdNr. - Optional]</p>
              </div>
              <p className="text-xs text-muted-foreground italic">
                Optional: Die W-IdNr. wird seit 2022 vergeben und kann zusätzlich angegeben werden.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">Berufsbezeichnung und berufsrechtliche Regelungen</h2>
              <p className="text-muted-foreground leading-relaxed">
                [NUR ERFORDERLICH FÜR FREIBERUFLER WIE RECHTSANWÄLTE, ÄRZTE, ARCHITEKTEN ETC.]
              </p>
              <div className="bg-muted/50 rounded-lg p-4 space-y-2">
                <p className="text-muted-foreground">
                  <span className="font-medium text-foreground">Berufsbezeichnung:</span> [z.B. Rechtsanwalt]
                </p>
                <p className="text-muted-foreground">
                  <span className="font-medium text-foreground">Zuständige Kammer:</span> [z.B. Rechtsanwaltskammer Berlin]
                </p>
                <p className="text-muted-foreground">
                  <span className="font-medium text-foreground">Verliehen in:</span> [Land]
                </p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
              <div className="bg-muted/50 rounded-lg p-4 space-y-1">
                <p className="font-medium text-foreground">[NAME DES VERANTWORTLICHEN]</p>
                <p className="text-muted-foreground">[STRASSE UND HAUSNUMMER]</p>
                <p className="text-muted-foreground">[PLZ UND ORT]</p>
              </div>
              <p className="text-xs text-muted-foreground italic">
                Bei kleinen Unternehmen oft identisch mit dem Geschäftsführer/Inhaber.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">EU-Streitschlichtung</h2>
              <p className="text-muted-foreground leading-relaxed">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) 
                bereit, die Sie unter folgendem Link finden:
              </p>
              <p className="text-muted-foreground">
                <a 
                  href="https://ec.europa.eu/consumers/odr/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-primary hover:underline"
                >
                  https://ec.europa.eu/consumers/odr/
                </a>
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
              <p className="text-muted-foreground leading-relaxed">
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
              <p className="text-xs text-muted-foreground italic mt-2">
                Hinweis: Sollten Sie zur Teilnahme an einem Streitbeilegungsverfahren verpflichtet 
                sein (z.B. aufgrund Ihrer Branche), passen Sie diesen Absatz entsprechend an.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">Haftung für Inhalte</h2>
              <p className="text-muted-foreground leading-relaxed">
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen 
                Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir 
                als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde 
                Informationen zu überwachen oder nach Umständen zu forschen, die auf eine 
                rechtswidrige Tätigkeit hinweisen.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den 
                allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist 
                jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. 
                Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte 
                umgehend entfernen.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">Haftung für Links</h2>
              <p className="text-muted-foreground leading-relaxed">
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir 
                keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine 
                Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige 
                Anbieter oder Betreiber der Seiten verantwortlich.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">Urheberrecht</h2>
              <p className="text-muted-foreground leading-relaxed">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten 
                unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, 
                Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes 
                bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
